// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';
import window from 'window-or-global';
import { domTrigger } from '../../lib/dom-event';
import { bind } from '@confluence-classic/confluence-event_DO_NOT_USE';

export default function adg3Plugin() {
	const Editor = window.Confluence.Editor;

	const toolbarId = 'searchreplace';

	/** A buffer of key codes pressed while waiting for the search bar to slide out */
	let keycodeBuffer = null;

	const cancelKeyboardFunction = function (e) {
		e.preventDefault();
		e.stopPropagation();
	};

	/**
	 * Buffer any character codes the user is typing but also prevent
	 * the event that is instigating them.
	 */
	const bufferTextFunction = function (e) {
		cancelKeyboardFunction(e);

		let keyCode = e.which;
		// IE8 doesn't have charCode for keypress event
		if (!keyCode) {
			keyCode = e.charCode ? e.charCode : e.keyCode;
		}

		// Firefox and Opera wrongly raise keypress for control characters
		if (keyCode < 48) {
			return;
		}

		keycodeBuffer.push(keyCode);
	};

	// Handle UTF-16 surrogate pair character codes
	const surrogatePairFixedFromCharCode = function (code) {
		if (code > 0xffff) {
			code -= 0x10000;
			return String.fromCharCode(
				// the bitwise operations are expected below
				/* eslint-disable no-bitwise */
				0xd800 + (code >> 10),
				0xdc00 + (code & 0x3ff),
				/* eslint-enable no-bitwise */
			);
		} else {
			return String.fromCharCode(code);
		}
	};

	/**
	 * Block keypresses in the editor and buffers them.
	 */
	const block = function () {
		const ed = window.tinymce.activeEditor;

		keycodeBuffer = [];

		ed.on('KeyDown', bufferTextFunction);
		ed.on('KeyPress', cancelKeyboardFunction);
		ed.on('KeyUp', cancelKeyboardFunction);
	};

	/**
	 * Unblock the keyboard events and return any buffered text.
	 */
	const unblock = function () {
		const ed = window.tinymce.activeEditor;
		ed.off('KeyDown', bufferTextFunction);
		ed.off('KeyPress', cancelKeyboardFunction);
		ed.off('KeyUp', cancelKeyboardFunction);

		let bufferedText = '';
		for (let i = 0; i < keycodeBuffer.length; i++) {
			bufferedText += surrogatePairFixedFromCharCode(keycodeBuffer[i]);
		}

		return bufferedText.toLowerCase();
	};

	const createToolbar = () => {
		block();
		const body = $('body');
		const animate = !body.hasClass('no-tools') || body.hasClass('no-tools-toolbars-visible');
		domTrigger(document, 'createContextToolbarRow.Toolbar', {
			id: toolbarId,
			buttons: Editor.searchToolbar.Buttons,
			topToolbar: true,
			editorAdjacent: true,
			animate,
			onVisible() {
				const buffered = unblock();
				// set any buffered text
				Editor.searchManager.onVisible(buffered);

				// To aid testing, you can check for this in tests after activating the toolbar.
				// This needs to live here since event blocking means that if it isn't the very
				// last thing done then events can be lost (and async tests can fail).
				Editor.searchManager.initialised = true;
			},
		});
		unblock();
	};

	const toggleToolbar = function () {
		const button = $('#rte-button-searchreplace');
		const enable = !button.hasClass('active');

		if (enable) {
			button.addClass('active');
			if (!Editor.searchManager) {
				Editor.searchManager = new Editor.SearchManager(toolbarId);
			}
			Editor.searchManager.init();
			domTrigger(document, 'enableContextToolbarRow.Toolbar', {
				id: 'searchreplace',
			});
		} else {
			button.removeClass('active');
			Editor.searchManager.onHide();
			domTrigger(document, 'disableContextToolbarRow.Toolbar', {
				id: 'searchreplace',
			});

			// IE and Webkit need you to focus on the iframe first and then the editor. (Firefox won't work if you do this.)
			if (!window.tinymce.Env.gecko) {
				frames['wysiwygTextarea_ifr'].focus();
			}
			window.tinymce.activeEditor.focus();
		}
	};

	return {
		init(ed) {
			ed.addCommand('mceSearchReplaceToolbar', () => {
				ed.undoManager.ignore(() => {
					toggleToolbar();
				});
			});

			ed.addCommand('mceConfSearch', (ui, parameters) => {
				if (!Editor.searchManager) {
					return;
				}

				parameters = parameters || {};

				if (
					parameters.backwards &&
					!window.tinymce.activeEditor.plugins.customtoolbar.isToolbarButtonEnabled(
						'search-toolbar-find-previous-button',
					)
				) {
					Editor.searchManager.focus();
					return;
				}

				if (
					!parameters.backwards &&
					!window.tinymce.activeEditor.plugins.customtoolbar.isToolbarButtonEnabled(
						'search-toolbar-find-next-button',
					)
				) {
					Editor.searchManager.focus();
					return;
				}

				Editor.searchManager.find(parameters.backwards, parameters.onFound, parameters.onNotFound);
			});

			ed.addCommand('mceConfReplaceAll', (ui, parameters) => {
				if (!Editor.searchManager) {
					return;
				}

				parameters = parameters || {};

				if (
					!window.tinymce.activeEditor.plugins.customtoolbar.isToolbarButtonEnabled(
						'search-toolbar-replaceall-button',
					)
				) {
					return;
				}

				Editor.searchManager.replaceAll(parameters.onReplaced, parameters.onNotReplaced);
			});

			ed.addCommand('mceConfSearchClose', () => {
				if (!Editor.searchManager) {
					return;
				}

				//toogle toolbar to close it.
				ed.undoManager.ignore(() => {
					ed.execCommand('mceSearchReplaceToolbar', false, null);
				});
			});

			// Register buttons
			ed.addButton('searchreplace', {
				title: 'searchreplace.search_desc',
				cmd: 'mceSearchReplaceToolbar',
			});

			/**
			 * The first press of ctrl + f should display the toolbar. Subsequent presses should focus the find box.
			 */
			if (!(window.tinymce.Env.ie == 8)) {
				ed.addShortcut('ctrl+f', 'searchreplace.search_desc', () => {
					if (Editor.searchManager && Editor.searchManager.isVisible()) {
						Editor.searchManager.focus();
					} else {
						ed.undoManager.ignore(() => {
							ed.execCommand('mceSearchReplaceToolbar', false, false, {
								skip_undo: true,
							});
						});
					}
				});
			}

			bind('rte-ready', () => {
				createToolbar();
				domTrigger(document, 'disableContextToolbarRow.Toolbar', {
					id: 'searchreplace',
				});
			});
		},

		getInfo() {
			return {
				longname: 'Search/Replace',
				author: 'Atlassian',
				authorurl: 'http://www.atlassian.com',
				infourl: 'http://www.atlassian.com',
				version: `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}`,
			};
		},
	};
}
